import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { LocaleCode } from '@/i18n'
//import type { NavigationGuardNext, RouteLocation, NavigationGuardReturn } from 'vue-router'

export const SupportedLocales = {
  ca: { name: 'Català' },
  en: { name: 'English' },
  es: { name: 'Español' },
  et: { name: 'Eesti keel' },
  nb: { name: 'Norsk' },
  ro: { name: 'Română' },
}

export function useI18nStore() {
  const { locale } = useI18n({ useScope: 'global' })

  const getters = {
    get supportedLocales() {
      return computed(() => Object.keys(SupportedLocales) as string[])
    },
    get defaultLocale() {
      return computed(() => (import.meta.env.VITE_DEFAULT_LOCALE as string) || ('en' as string))
    },
    get userLocale() {
      const locale = window.navigator.language || getters.defaultLocale.value
      return computed(() => {
        return {
          locale: locale,
          localeNoRegion: locale.split('-')[0],
        }
      })
    },
    get persistedLocale() {
      return computed(() => {
        const persistedLocale = localStorage.getItem('user-locale') as LocaleCode
        if (actions.isLocaleSupported(persistedLocale)) {
          return persistedLocale
        } else {
          return null
        }
      })
    },
    get currentLocale() {
      return computed(() => locale.value)
    },
    /* get routeMiddleware() {
      return function (
        to: RouteLocation,
        _from: RouteLocation,
        next: NavigationGuardNext,
      ): NavigationGuardReturn {
        const paramLocale = to.params.locale as string
        if (!actions.isLocaleSupported(paramLocale as LocaleCode)) {
          return next(actions.guessDefaultLocale())
        }
        actions.switchLanguage(paramLocale as LocaleCode)
        return next()
      }
    }, */
  }

  const actions = {
    isLocaleSupported(locale: string) {
      return getters.supportedLocales.value.includes(locale)
    },
    switchLanguage(newLocale: LocaleCode) {
      locale.value = newLocale
      localStorage.setItem('user-locale', newLocale)
      return newLocale
    },
    guessDefaultLocale() {
      const userPersistedLocale = getters.persistedLocale.value
      if (userPersistedLocale) {
        return userPersistedLocale
      }
      const userPreferredLocale = getters.userLocale.value
      if (actions.isLocaleSupported(userPreferredLocale.locale)) {
        return userPreferredLocale.locale
      }
      if (actions.isLocaleSupported(userPreferredLocale?.localeNoRegion ?? '')) {
        return userPreferredLocale.localeNoRegion
      }
      return getters.defaultLocale.value
    },
  }

  const p = getters.persistedLocale.value
  if (p) actions.switchLanguage(p)
  else actions.switchLanguage('en')

  return { actions, getters }
}
